import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-pagamenti-immissione-manuale',
	templateUrl: './pagamenti-immissione-manuale.component.html',
	styleUrls: ['./pagamenti-immissione-manuale.component.css']
})
export class PagamentiImmissioneManualeComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('searchInput') searchInput;
	@ViewChild('immissionePagamentiForm') immissionePagamentiForm;
	@ViewChild('pagamentoAdd') pagamentoAdd;

	searchId: number;
	findComplete = true;
	modalInput:any = {
		data: null
	};

	sommaPagata: any = null;
	dataPagamento: any = null;
	dataAccredito: any = null;
	riferimentoBollettino: any = null;
	canale: any = null;
	rata: any = null;

	canaliPagamentoSync:Subscription;
	emissioniSync:Subscription;
	praticheSync:Subscription;
	canaliPagamento: any[] = [];
	emissioni: any[] = [];
	pratiche: any[] = [];

	datiAnagrafica: any = null;
	datiPratica: any = null;
	dettaglioPratica: any = {};

	constructor(protected dataService: DataService) {
		super(dataService, 'pagamenti-immissione-manuale');
	}

	ngOnInit() {
		this.praticheSync = this.dataService.pratiche$.subscribe(
			() => {
				if (this.searchId) {
					this.getPratica();
				}
			});
	}

	ngAfterViewInit() {
		if ( this.checkPermission('pagamenti-immissione-manuale','read') ) {
			this.immissionePagamentiForm.valueChanges
				.subscribe(data => { this.getPratica(); });
		}
	}

	getPratica() {
		this.findComplete = false;
		this.dataService.getPraticaByIdPrat(this.searchId, (pratica) => {
			this.datiPratica = pratica;
			if(this.datiPratica) {
				console.log('PRATICA:', this.datiPratica);
				this.getAnagrafica();
				this.modalInput.data = this.datiPratica;
			}
			else {
				this.modalInput.data = null;
			}
			this.findComplete = true;
		});
	}

	getAnagrafica() {
		this.dataService.getPersonById(this.datiPratica.anagrafica_id, (person) => {
			console.log("pagamenti person", person);
			this.datiAnagrafica = person;
			console.log('ANAGRAFICA:', this.datiAnagrafica);
		});
	}

	reset() {
		this.searchId = null;
		this.datiPratica = null;
		this.datiAnagrafica = null;
		this.findComplete = true;
		this.pagamentoAdd.reset();
		//this.searchInput.nativeElement.focus();
	}

	getInnerEvents(event: any) {
		let localComuneId = true;
		let localFilters: any = [];
		let localSets: any = {};
		console.log(event);
		if(event.aggiungiPagamento){
			localFilters.push({ "uid": event.uid });
			localSets = event.setValue;
			this.dataService.insertPagamento(event.uid, event.setValue,true,(err,data) => {
				if (err) {
					console.log('insertPagamento|error',err);
				}else {
					console.log('insertPagamento|success', data, localFilters)
					/*this.dataService.update("pagamenti", localFilters, localSets, localComuneId, (err,res) => {
						if (err) {
							console.log('update pagamenti|error',err);
						}
						else {
							console.log('update pagamenti|success',res);
						}
						this.reset();
					});*/
				}
			});
		}

	}

	ngOnDestroy() {
		if ( this.checkPermission('pagamenti-immissione-manuale','read') ) {
			this.praticheSync.unsubscribe();
		}
	}
}
